/* src/app/components/payroll/timesheets/timesheet-provider-list/timesheet-provider-list.component.css */
.line1 {
  display: flex;
  justify-content: space-between;
}
.filters {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.ant-select-selector {
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.check-filter {
  width: 100%;
  height: 32px;
  padding: 0 11px;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.85);
}
:host ::ng-deep .accordion-body {
  gap: 12px !important;
}
.message {
  margin-bottom: 0px;
  margin-top: 16px;
  margin-left: 8px;
  font-weight: 500;
}
:host ::ng-deep .ant-form-item {
  margin-bottom: 0px !important;
}
/*# sourceMappingURL=timesheet-provider-list.component-SJ5YWK3Z.css.map */
